import * as React from 'react';
import { Loader, NString } from '@mobalytics/shared';
import { AllowedActionsT } from '../../../../payment.types';
import { useStripeFlowConfirmationInfo } from '../stripe-flow-confirmation-info.hook';
import { StripeFlowElementsProvider } from '../stripe-flow-elements-provider.component';
import { StripeNewFlowConfirmation } from './stripe-new-flow-confirmation.component';

interface Props {
  className?: string;
  planId: string;
  productAbbreviation: string;
  coupon: NString;
  allowedActions: AllowedActionsT;
  shouldPrepareBillingInfoFirst: boolean;
  submitButtonLabel: string;
  paypalButton?: React.ReactNode;
}

export const StripeNewFlow: React.FC<Props> = (props) => {
  const {
    className,
    submitButtonLabel,
    planId,
    productAbbreviation,
    coupon,
    allowedActions,
    shouldPrepareBillingInfoFirst,
    paypalButton,
  } = props;
  const { loading, fetchConfirmationInfo, confirmationInfo } = useStripeFlowConfirmationInfo({
    productAbbreviation,
    planId,
    coupon,
    allowedActions,
  });

  React.useEffect(() => {
    fetchConfirmationInfo(shouldPrepareBillingInfoFirst);
  }, [fetchConfirmationInfo, shouldPrepareBillingInfoFirst]);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className={className}>
      {confirmationInfo && (
        <StripeFlowElementsProvider confirmationInfo={confirmationInfo}>
          <StripeNewFlowConfirmation
            confirmationInfo={confirmationInfo}
            submitButtonLabel={submitButtonLabel}
            productAbbreviation={productAbbreviation}
            paypalButton={paypalButton}
          />
        </StripeFlowElementsProvider>
      )}
    </div>
  );
};
